import c1 from "../assets/images/c1.png";
import c2 from "../assets/images/c2.png";
import c3 from "../assets/images/c3.png";
import c4 from "../assets/images/c4.png";
import c5 from "../assets/images/c5.png";
import c6 from "../assets/images/c6.png";
import c7 from "../assets/images/c7.png";
import c9 from "../assets/images/c9.png";
import c11 from "../assets/images/c11.png";
import c12 from "../assets/images/c12.png";
import djnightVideo from "../assets/images/djnight.mp4";

export const CONTENT_CATALOG = [
  {
    id: "1",
    title: "Midnight Sessions",
    artist: "DJ Nova",
    type: "LIVE DJ SET",
    searchType: "Live Show",
    variant: "live",
    genre: "Electronic",
    duration: "1:23:45",
    plays: "8.2K",
    likes: 1000,
    comments: 42,
    collects: 342,
    collected: 342,
    artwork: c1,
    image: c1,
    videoSrc: djnightVideo,
    audioSrc: djnightVideo,
    isLive: true,
    viewerCount: 847,
    viewers: 847,
    badges: ["Featured"],
    mood: "After dark",
    highlight: "Orb suggests a save at 41:12",
    collectible: true,
    freshness: "Live now",
    description: "A late-night live room with a high-energy electronic run and collectible moments.",
    stats: [
      { label: "Watching", value: "847" },
      { label: "Collected", value: "342/500" },
      { label: "Comments", value: "42" },
    ],
  },
  {
    id: "2",
    title: "Culture & Sound",
    artist: "Maya Chen",
    type: "EDITORIAL",
    lobbyTypeLabel: "Editorial",
    searchType: "Editorial",
    variant: "editorial",
    genre: "World",
    duration: "12:30",
    plays: "3.1K",
    likes: 128,
    comments: 18,
    collects: 418,
    collected: 128,
    artwork: c2,
    image: c2,
    badges: ["New"],
    viewers: 234,
    mood: "Field notes",
    highlight: "Short cultural dispatch",
    collectible: false,
    freshness: "New essay",
    description:
      "A longform editorial on how sonic identity, fashion, and internet-native curation are collapsing into one shared creator surface.",
    stats: [
      { label: "Read time", value: "12 min" },
      { label: "Saves", value: "418" },
      { label: "Highlights", value: "34" },
    ],
    article: [
      "In the ever-evolving landscape of music and culture, artists continue to push boundaries and redefine what it means to create meaningful content.",
      "This piece explores the intersection of sound, visual art, and community, examining how platforms like Sound Vista reshape the relationship between artist and listener.",
      "The convergence of live performance, digital curation, and community-driven discovery suggests a future where listening becomes a designed environment rather than a flat stream.",
    ],
  },
  {
    id: "3",
    title: "Bass Frequencies",
    artist: "Sub Zero",
    type: "PODCAST",
    lobbyTypeLabel: "Podcast",
    searchType: "Podcast",
    variant: "podcast",
    genre: "Electronic",
    duration: "45:12",
    plays: "5.7K",
    likes: 256,
    comments: 31,
    collects: 612,
    collected: 256,
    artwork: c3,
    image: c3,
    badges: ["Verified"],
    viewers: 56,
    mood: "Deep dive",
    highlight: "Breaks down club mutations",
    collectible: false,
    freshness: "Trending",
    description:
      "A voice-led breakdown of underground club infrastructure, touring economics, and how scenes survive after the hype cycle ends.",
    stats: [
      { label: "Listeners", value: "5.7K" },
      { label: "Completion", value: "71%" },
      { label: "Saves", value: "612" },
    ],
    chapters: [
      { time: "00:00", title: "Why scenes collapse after momentum" },
      { time: "08:25", title: "The economics of community-led spaces" },
      { time: "19:40", title: "Merch, tickets, collectibles" },
      { time: "31:08", title: "What resilient scenes share" },
    ],
  },
  {
    id: "4",
    title: "Golden Hour",
    artist: "Sunrise Collective",
    type: "LIVE SHOW",
    lobbyTypeLabel: "Music Show",
    searchType: "Live Show",
    variant: "live",
    genre: "Jazz",
    duration: "2:10:00",
    plays: "4.1K",
    likes: 198,
    comments: 22,
    collects: 89,
    collected: 89,
    artwork: c4,
    image: c4,
    isLive: true,
    viewerCount: 1243,
    viewers: 1243,
    mood: "Warm room",
    highlight: "Shared listening session replay",
    collectible: false,
    freshness: "Replay",
    description: "A warm live replay built around jazz textures, community chat, and slow golden-hour pacing.",
    stats: [
      { label: "Viewers", value: "1.2K" },
      { label: "Collectors", value: "89" },
      { label: "Moments", value: "11" },
    ],
  },
  {
    id: "5",
    title: "Street Sounds",
    artist: "Urban Echo",
    type: "DJ SET",
    lobbyTypeLabel: "DJ Set",
    searchType: "DJ Set",
    variant: "live",
    genre: "Hip Hop",
    duration: "1:05:30",
    plays: "2.4K",
    likes: 284,
    comments: 42,
    collects: 412,
    collected: 412,
    artwork: c5,
    image: c5,
    badges: ["Featured", "New"],
    viewers: 189,
    mood: "Street pressure",
    highlight: "High collect rate this week",
    collectible: true,
    freshness: "Limited drop",
    description: "A street-level DJ set with high collect activity and a tight city-session feel.",
    stats: [
      { label: "Listeners", value: "2.4K" },
      { label: "Collectors", value: "412" },
      { label: "Comments", value: "42" },
    ],
  },
  {
    id: "6",
    title: "Deep Dive",
    artist: "Ocean Mind",
    type: "PODCAST",
    searchType: "Podcast",
    variant: "podcast",
    genre: "Experimental",
    duration: "38:45",
    plays: "1.9K",
    likes: 167,
    comments: 14,
    collects: 67,
    collected: 67,
    artwork: c6,
    image: c6,
    viewers: 42,
    mood: "Slow focus",
    highlight: "Dense conversation, clean pacing",
    collectible: false,
    freshness: "Recommended",
    description: "A slower experimental conversation about attention, replay value, and memory design.",
    stats: [
      { label: "Listeners", value: "1.9K" },
      { label: "Completion", value: "64%" },
      { label: "Saves", value: "67" },
    ],
    chapters: [
      { time: "00:00", title: "The shape of attention" },
      { time: "09:45", title: "Making replay feel intentional" },
      { time: "22:10", title: "When memory becomes product" },
    ],
  },
  {
    id: "7",
    title: "MATTERS EP",
    artist: "Kenji Sato",
    type: "DJ SET",
    searchType: "DJ Set",
    variant: "live",
    genre: "Electronic",
    duration: "1:45:00",
    plays: "6.3K",
    likes: 412,
    comments: 73,
    collects: 195,
    collected: 195,
    artwork: c11,
    image: c11,
    mood: "Club pulse",
    highlight: "Works for late sessions",
    collectible: true,
    freshness: "Community pick",
    description: "A long-form electronic set with club pressure and late-session momentum.",
    stats: [
      { label: "Listeners", value: "6.3K" },
      { label: "Collectors", value: "195" },
      { label: "Moments", value: "47" },
    ],
  },
  {
    id: "8",
    title: "AJKS DJ SET",
    artist: "DJ AJKS",
    type: "LIVE SHOW",
    searchType: "Live Show",
    variant: "live",
    genre: "R&B",
    duration: "55:20",
    plays: "3.8K",
    likes: 301,
    comments: 42,
    collects: 88,
    collected: 301,
    artwork: c7,
    image: c7,
    videoSrc: djnightVideo,
    audioSrc: djnightVideo,
    isLive: true,
    viewerCount: 190,
    mood: "Soft launch",
    highlight: "High completion among return listeners",
    collectible: true,
    freshness: "Tonight",
    description: "Live from Sound Vista",
    stats: [
      { label: "Watching", value: "190" },
      { label: "Collected", value: "88/100" },
      { label: "Comments", value: "42" },
    ],
  },
  {
    id: "9",
    title: "Urban Stories",
    artist: "Street Poet",
    type: "EDITORIAL",
    searchType: "Editorial",
    variant: "editorial",
    genre: "Hip Hop",
    duration: "8:15",
    plays: "1.2K",
    likes: 88,
    comments: 9,
    collects: 45,
    collected: 45,
    artwork: c9,
    image: c9,
    mood: "Quick read",
    highlight: "Good for short sessions",
    collectible: false,
    freshness: "Fresh",
    description: "A short editorial read on street-level scenes, voice, and local sonic memory.",
    stats: [
      { label: "Read time", value: "8 min" },
      { label: "Saves", value: "45" },
      { label: "Highlights", value: "12" },
    ],
    article: [
      "The strongest local scenes leave traces in language, rhythm, and the way a block sounds after midnight.",
      "Urban storytelling makes those traces legible without sanding off the edges.",
    ],
  },
  {
    id: "10",
    title: "Deep Dive EP.12",
    artist: "Lena Park",
    type: "PODCAST",
    searchType: "Podcast",
    variant: "podcast",
    genre: "Experimental",
    duration: "52:30",
    plays: "6.3K",
    likes: 301,
    comments: 27,
    collects: 703,
    collected: 703,
    artwork: c12,
    image: c12,
    viewers: 42,
    mood: "Studio notes",
    highlight: "Memory design for premium audio",
    collectible: false,
    freshness: "New episode",
    description: "A calm, voice-first episode on memory design, listener retention, and premium storytelling.",
    stats: [
      { label: "Listeners", value: "6.3K" },
      { label: "Completion", value: "78%" },
      { label: "Saves", value: "703" },
    ],
    chapters: [
      { time: "00:00", title: "What listeners remember first" },
      { time: "11:12", title: "Designing for replay value" },
      { time: "26:40", title: "Signals that premium creators use" },
      { time: "41:50", title: "Retention beyond content" },
    ],
  },
];

export const PRIMARY_CONTENT_IDS = ["4", "5", "2", "3"];
export const BOTTOM_CONTENT_IDS = [];
export const MOBILE_STACK_IDS = ["1", "8", "2"];
export const LOBBY_ORBIT_CONTENT_IDS = ["4", "5", "2", "3", "1", "8", "6", "7", "9", "10"];

export const getContentById = (id) => (
  CONTENT_CATALOG.find((item) => item.id === String(id))
);

export const LOBBY_PRIMARY_CONTENT = PRIMARY_CONTENT_IDS.map(getContentById).filter(Boolean);
export const LOBBY_BOTTOM_CONTENT = BOTTOM_CONTENT_IDS.map(getContentById).filter(Boolean);
export const LOBBY_ORBIT_CONTENT = LOBBY_ORBIT_CONTENT_IDS.map(getContentById).filter(Boolean);

export const PLAYER_TRACKS = CONTENT_CATALOG;

export const SEARCH_RESULTS = CONTENT_CATALOG.slice(0, 9).map((item) => ({
  ...item,
  type: item.searchType,
}));

export const getPlayerQueue = () => PLAYER_TRACKS;
